import { createUseStyles } from 'react-jss';
import { Theme } from '@mui/material';

export const useStyles = createUseStyles((theme: Theme) => {
    const { color, radius, mq, font } = theme.custom;
    return {
        title: { display: 'inline-flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' },
        facts: {
            marginBottom: 16,
            padding: 14,
            borderRadius: radius.md,
            backgroundColor: color.surfaceMuted,
            border: `1px solid ${color.border}`,
        },
        toolbar: { display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 12, marginBottom: 12 },
        count: {
            marginLeft: 'auto',
            fontSize: 13,
            color: color.text.secondary,
            fontVariantNumeric: 'tabular-nums',
            [mq.sm]: { marginLeft: 0, width: '100%' },
        },
        list: { listStyle: 'none', margin: 0, padding: 0, display: 'flex', flexDirection: 'column', gap: 10 },
        row: {
            display: 'flex',
            gap: 14,
            alignItems: 'flex-start',
            padding: 12,
            borderRadius: radius.md,
            border: `1px solid ${color.border}`,
            backgroundColor: color.surface,
            [mq.sm]: { flexWrap: 'wrap' },
        },
        thumbs: { display: 'flex', gap: 8, flexShrink: 0 },
        thumb: {
            width: 84,
            height: 84,
            borderRadius: radius.sm,
            overflow: 'hidden',
            backgroundColor: color.surfaceMuted,
            border: `1px solid ${color.border}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 11,
            color: color.text.muted,
            [mq.xs]: { width: 64, height: 64 },
            '&:focus-visible': { outline: `2px solid ${color.focusRing}`, outlineOffset: 2 },
        },
        thumbImage: { display: 'block', width: '100%', height: '100%', objectFit: 'cover' },
        main: { flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 4 },
        line: { display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 6 },
        date: { fontWeight: 600, fontSize: 14, fontVariantNumeric: 'tabular-nums' },
        product: { fontSize: 13, color: color.text.primary, overflowWrap: 'anywhere' },
        sku: { fontFamily: font.mono, fontSize: 12, color: color.text.secondary },
        meta: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: '2px 12px',
            fontSize: 12,
            color: color.text.secondary,
            fontVariantNumeric: 'tabular-nums',
        },
        path: { maxWidth: 360, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontFamily: font.mono },
        rowActions: { flexShrink: 0, [mq.sm]: { width: '100%', display: 'flex', justifyContent: 'flex-end' } },
        more: { display: 'flex', justifyContent: 'center', padding: '16px 0 4px' },
    };
});
